export default "__VITE_ASSET__CkiPD754__"